import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SignalniLagerService {
  constructor(private _http: HttpClient) {}

  poslovnicaPopis(a: any) {
    return this._http.post(AppConfig.ipAddress + 'poslovnicaPopis', a)
      .pipe(map((res: any) => res));
  }

  zalihaPopis(a: any) {
    return this._http.post(AppConfig.ipAddress + 'zalihaPopis', a)
      .pipe(map((res: any) => res));
  }

  zalihaUredi(a: any) {
    return this._http.post(AppConfig.ipAddress + 'zalihaUredi', a)
      .pipe(map((res: any) => res));
  }


}
